import { getStore } from '../store';

export default function getIANATimeZoneIdFromWindowsId(
    windowsTimeZoneId: string
): string | undefined {
    return getStore().TimeZoneAlternateNames.get(windowsTimeZoneId)?.[0];
}
